<mf-page title="Nueva operación">
  <mf-operation (save)="save($event)" />
</mf-page>
